import React from 'react';

const AppFooter = () => (
    <footer className="app-footer">
        <span className="footer-brand">Swahili For Foreigners &copy; {new Date().getFullYear()}</span>
        <div className="footer-links">
            <a href="#">Contact</a>
            <a href="#">About Us</a>
            <a href="#">Terms</a>
        </div>
    </footer>
);

export default AppFooter;
